<template>
  <div class="wrap-content">
    <!-- <div id="assets"></div> -->
    <div class="hello">
      <div class="wrap-brand">
        <img src="../assets/abi-vertical.png" alt="" class="brand" />
      </div>
      <div class="content">
        <div class="content-left">
          <!-- <p class="brand">MetalX</p> -->
          <h3 class="title">Transaksi Perdagangan Berjangka Multilateral Dalam Bursa</h3>
          <p class="tag-line">
            Membuat transaksi berjangka anda jadi lebih aman, cepat dan mudah
          </p>
          <router-link to="/register">
            <button class="btn-primer">Daftar</button>
          </router-link>
          <router-link class="login" to="/login">
            <button class="btn-scondary">Masuk</button>
          </router-link>
        </div>
        <div class="content-right">
          <img src="../assets/fron-elemenet.png" alt="" class="element" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-primer,
.btn-scondary {
  width: 220px;
  margin-right: 20px;
  font-size: 14px;
  height: 47px;
}

.login {
  font-weight: bold;
  color: #c59733;
  cursor: pointer;
}

.wrap-content {
  min-height: 100vh;
  background-image: url("../assets/iconImage/bg-bottom.png");
  background-repeat: no-repeat;
  background-attachment: fixed;
  /* background-position: -68.66vw 100%;
  background-size: 173% 40%; */
  background-size: 100%;
  background-position: bottom right;
}

#assets {
  position: absolute;
  width: 100%;
  height: 95%;
  background: #c59733;
  border-bottom-right-radius: 100%;
}

#assets::after {
  content: "";
  position: absolute;
  width: 99%;
  height: 99%;
  background: white;
  border-bottom-right-radius: 100%;
}

.hello {
  display: flex;
  height: 100%;
  background-color: transparent;
  width: 70%;
  margin: 0 auto;
  position: relative;
  flex-direction: column;
  top: 5rem;
}

.content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.element {
  width: 95%;
}

/* .content-left{
  text-align: center;
  display: none;
} */

/* .content-left img{
  width: 50px;
  height: 222.5px;
} */

/* .content-right{
  flex: 2;
  padding: 20px;
  margin: 0 0 0 79px;
} */

.brand {
  font-size: 25px;
  font-weight: bold;
  width: 140px;
}

.title {
  font-size: 47px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  margin: 0 0 25px;
  width: 537px;
}

.tag-line {
  width: 497px;
  /* font-size: 18px; */
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  margin: 0 0 50px;
}

.have-account {
  font-size: 12px;
  margin: 10px;
}

@media (min-width: 720px) and (max-width: 1020px) {
  .wrap-content {
    flex-direction: row;
  }
  .hello {
    flex-wrap: wrap;
    flex-direction: row;
  }

  .content-left {
    text-align: center;
  }

  .btn-primer,
  .btn-scondary {
    font-size: 14px;
    height: 47px;
  }

  .have-account {
    text-align: center;
    margin: 20px 0;
  }
}

@media (max-width: 720px) {
  .hello {
    width: 90%;
    top: 0;
    gap: 2.5rem;
    padding: 3rem 0px;
    text-align: center;
  }
  .wrap-content {
    background-position: -68.66vw 100%;
    background-size: 173% 40%;
  }

  .wrap-brand {
    text-align: center;
  }

  .brand {
    width: 11rem;
  }

  .title {
    width: 97%;
    font-size: 22px;
    font-weight: bold;
    margin: 0px auto 19px;
  }

  .tag-line {
    width: 80%;
    font-size: 11px;
    margin: 0 auto 45px;
  }

  .content {
    flex-direction: column;
  }

  .element {
    width: 72%;
    position: relative;
    right: -58px;
  }

  .btn-primer {
    margin-bottom: 25px;
  }
}
</style>
